import {inject} from "@angular/core";
import {Router, ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable, of, EMPTY} from "rxjs";
import {mergeMap, take} from "rxjs/operators";
import {LANDING_ROUTE} from "src/app/app-routing.module";
import {EventService} from "@services";
import {EventItem, FetchEventByIdRequest} from "@model";

export const EventDetailsPublicResolver: ResolveFn<Observable<EventItem | null> |
  Promise<EventItem> | EventItem> =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   eventService: EventService = inject(EventService),
   router: Router = inject(Router))
    : Observable<EventItem | null> |
    Promise<EventItem> | EventItem => {
    let eventId = route.queryParams["eventId"];
    if (!eventId) {
      router.navigate([LANDING_ROUTE]);
      return EMPTY;
    } else {
      return eventService.findEventById(
        new FetchEventByIdRequest(eventId), true)
        .pipe(
          take(1),
          mergeMap((res: EventItem | null) => {
            if (res) {
              return of(res);
            } else {
              router.navigate([LANDING_ROUTE]);
              return EMPTY;
            }
          })
        );
    }
  }
